import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-input-close",
  "use": "icon-input-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-input-close\">\n    <path d=\"M8 .245a7.768 7.768 0 1 0 0 15.537A7.768 7.768 0 0 0 8 .245zm3.331 10.093a.712.712 0 0 1-1.007 1.007L8 9.02l-2.324 2.324a.712.712 0 1 1-1.007-1.007l2.324-2.325L4.669 5.69a.712.712 0 1 1 1.007-1.007L8 7.006l2.324-2.324a.712.712 0 0 1 1.007 1.007L9.007 8.013l2.324 2.325z\" fill=\"#DDD\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol